;(function($, g_analytics){

    'use strict';

    var rnn = window.rnn;

    function send_to_ga(eventType, clickAction, data, hitCallback){
        var trackData = {
            tracker: 'findaTracker.send',
            hitType: 'event',
            network: 'lc',
            event_type: eventType,
            click_action: clickAction,
            data: data,
            hitCallback: hitCallback,
            token: 'findaEvent'
        };

        g_analytics.create_ga_event(trackData);
    }

    function handle_view_events() {
        $('[data-ad-tracking]').each(function(){
            var data = $(this).data('adTracking');
            send_to_ga(data.event_type, data.click_action, data);
        });
    }

    function get_adData($el) {
        var $parentEl = $('[data-ad-tracking]'),
            data = $parentEl.data('adTracking') || {};
        return data;
    }

    function track_phoneclick($el){
        var data = get_adData($el);

        if ($el.data('dealer-event') === true) {
            data = get_dealer_info(data);
        }

        send_to_ga('phone_clicktocall', 'click_action', data);
    }

    function track_advertisercontactclick($el){
        var data = get_adData($el);

        if ($el.data('dealer-event') === true) {
            data = get_dealer_info(data);
        }

        send_to_ga('contact_clicktoshow', 'click_action', data);
    }

    function track_websiteclick($el){
        var data = get_adData($el);

        if ($el.data('dealer-event') === true) {
            data = get_dealer_info(data);
        }

        send_to_ga('website_clicktocall', 'click_action', data);
    }

    function track_shortlist($el){
        var isDetail = $('.classifiedsApp').length > 0,
            $parentEl;

        if (isDetail) {
            // detail page
            $parentEl = $el.closest('body').find('[data-ad-tracking]');
        } else {
            // listing item
            $parentEl = $el.closest('[data-ad-tracking]');
        }

        var data = $parentEl.data('adTracking'),
            event_type = 'shortlist',
            click_action = false;

        send_to_ga(event_type, click_action, data);
    }

    function get_dealer_info(data) {
        var $dealer = $('[data-dealer-tracking]'),
            dealerData = $dealer.data('dealer-tracking');

        if (dealerData) {
            data.ad_id = dealerData.dealer_id;
            data.ad_name = dealerData.dealer_name;
            data.ad_address = dealerData.dealer_address;
        }

        return data;
    }

    function track_advertiser($el) {
        var data = $el.closest('[data-ad-tracking]').data('ad-tracking');
        send_to_ga('advertiser-page_click', 'click_action', data);
    }

    function classifiedsInteractions() {
        $('#adContactForm button[type="submit"]').click(function() {
            var data = get_adData();
            send_to_ga('contact_clicktocall', 'click_action', data,
                function() {
                    $('#adContactForm').submit();
                });

            return false;
        });

        $('.classifiedsApp .listingRight .advertiser-logo a').click(function() {
            var data = get_adData();
            send_to_ga('advertiser_search', '', data);
        });

        $('.advertiserTrack').click(function(e) {
            track_advertiser($(this));
        });

        handle_view_events();
    }


    function initTrackFindaEvents() {
        // init
        classifiedsInteractions();
    }

    rnn.modules.register('trackFindaEvents', {
        init: initTrackFindaEvents,
        track_shortlist: track_shortlist,
        track_phoneclick: track_phoneclick,
        track_websiteclick: track_websiteclick,
        track_advertisercontactclick: track_advertisercontactclick,
    });

})(jQuery, window.rnn.modules.g_analytics);


